import { storeToRefs } from "pinia"
import { useSettingsStore } from "@/stores/settings"

const calculateDistanceBetweenCoordinates = (latitude1, longitude1, latitude2, longitude2) => {
	const latFrom = deg2rad(latitude1)
	const lonFrom = deg2rad(longitude1)
	const latTo = deg2rad(latitude2)
	const lonTo = deg2rad(longitude2)

	const latDelta = latTo - latFrom
	const lonDelta = lonTo - lonFrom

	const angle = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(latDelta / 2), 2) + Math.cos(latFrom) * Math.cos(latTo) * Math.pow(Math.sin(lonDelta / 2), 2)))
	return angle * 6371000 * 100
}

const deg2rad = (deg) => {
	return deg * (Math.PI / 180)
}

const ddToDms = (lat, lon) => {
	function convert(dec) {
		const deg = Math.floor(Math.abs(dec))
		const minFloat = (Math.abs(dec) - deg) * 60
		const min = Math.floor(minFloat)
		const sec = ((minFloat - min) * 60).toFixed(2)
		return { deg, min, sec }
	}

	const latDMS = convert(lat)
	const lonDMS = convert(lon)

	const latCard = lat >= 0 ? "N" : "S"
	const lonCard = lon >= 0 ? "E" : "W"

	return {
		latitude: `${latDMS.deg}°${latDMS.min}'${latDMS.sec}" ${latCard}`,
		longitude: `${lonDMS.deg}°${lonDMS.min}'${lonDMS.sec}" ${lonCard}`,
	}
}

const dmsToDd = (dmsString) => {
    const convertSingle = (str) => {
        const regex = /(\d+)[°\s]+(\d+)['\s]+([\d.]+)[^NSEW]*([NSEW])/i
        const match = str.match(regex)

        if (!match) return null

        const deg = parseFloat(match[1])
        const min = parseFloat(match[2])
        const sec = parseFloat(match[3])
        const dir = match[4].toUpperCase()

        let dd = deg + min / 60 + sec / 3600

        if (dir === "S" || dir === "W") {
            dd = dd * -1
        }
        return parseFloat(dd.toFixed(6))
    }

    const parts = dmsString.split(/(?<=[NS])\s+/i)

    if (parts.length < 2) return null

    const latitude = convertSingle(parts[0]);
    const longitude = convertSingle(parts[1]);

    return {
        latitude: latitude,
        longitude: longitude,
    }
}

const formatCoordinates = (latitude, longitude) => {
	const { coordinatesFormat } = storeToRefs(useSettingsStore())

	// dms
	if (coordinatesFormat.value === "dms") {
		const converted = ddToDms(latitude, longitude)
		return `${converted.latitude}, ${converted.longitude}`
	}

	// dd
	return `${Math.round(latitude * 100000) / 100000}, ${Math.round(longitude * 100000) / 100000}`
}

export { calculateDistanceBetweenCoordinates, deg2rad, formatCoordinates, dmsToDd, ddToDms }
